export default "__VITE_ASSET__DUReD18R__"